import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';

/**
 * @typedef {Object} MivaAppliedFacet
 * @prop {string|number} prompt
 * @prop {string|number} value
 */

export class CheckboxAppliedFacet extends LitElement {
	static formAssociated = true;

	static get properties () {
		return {
			name: {
				type: String
			},
			values: {
				type: Array
			}
		};
	}

	/**
	 * @type {string}
	 */
	get selectedRange () {
		const first = this.sortedValues?.[0];
		const last = this.sortedValues?.[this.sortedValues?.length - 1];

		return `${first?.prompt} - ${last?.prompt}`;
	}

	/**
	 * @type {MivaAppliedFacet[]}
	 */
	get sortedValues () {
		return this.values
			?.sort((a, b) => a.value - b.value);
	}

	/**
	 * Expose a `form` property so Facet.js allows the element to be clicked to clear the facet
	 */
	get form () {
		return this._internals.form;
	}

	constructor () {
		super();

		/**
		 * @type {ElementInternals}
		 */
		this._internals = this.attachInternals();

		/**
		 * @type {string}
		 */
		this.name = '';

		/**
		 * @type {MivaAppliedFacet[]}
		 */
		this.values = [];
	}

	// No shadow dom
	createRenderRoot () {
		return this;
	}

	render () {
		return html`
			<button type="button" class="g-facets__applied-label">
				<span class="g-facets__applied-label-icon u-icon-cross"></span>
				<span class="g-facets__applied-label-text">${this.name}: ${this.selectedRange}</span>
			</button>
		`;
	}
};

defineCustomElement('x-checkbox-applied-facet', CheckboxAppliedFacet);
